import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseCellRendererComponent } from '@y42/ag-grid';
import { connectState } from '@y42/angular/util';
import { OrchestrationNodeLogsDialogService } from '../orchestration-node-logs-dialog/orchestration-node-logs-dialog.service';

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-job-logs-cell-renderer',
  template: `
    <button y42StopPropagation mat-stroked-button class="leading-7 view-logs" (click)="showLogs()">
      <fa-icon class="fs-1" [icon]="['fal', 'bars']"></fa-icon>
      <span class="ml-2">Job logs</span>
    </button>
  `,
  styles: [
    `
      :host {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .view-logs {
        padding: 3px 10px !important;
        line-height: 1.75rem !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationJobLogsCellRendererComponent extends BaseCellRendererComponent<{
  jobId: string;
  path: string;
}> {
  constructor(private readonly orchestratioNodeLogDialogService: OrchestrationNodeLogsDialogService) {
    super();
  }
  readonly state = connectState(this, {
    jobIdAndPath: this.valueAsSingle$,
  });

  showLogs() {
    if (!this.state.jobIdAndPath) {
      return;
    }
    this.orchestratioNodeLogDialogService.showDialog({ ...this.state.jobIdAndPath });
  }
}
